const items = [
  "Web Design", "Development", "SEO", "Branding", "Conversion-First",
  "7-Day Delivery", "Free Demo First", "Unlimited Revisions",
];

const Row = () => (
  <div className="flex items-center shrink-0">
    {items.map((item) => (
      <span key={item} className="flex items-center shrink-0">
        <span className="font-display font-light italic text-2xl sm:text-3xl text-white/85 px-6 sm:px-10 whitespace-nowrap">
          {item}
        </span>
        <span className="w-2.5 h-2.5 bg-brand rotate-45 shrink-0" aria-hidden="true" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative border-y hairline py-5 sm:py-6 overflow-hidden bg-panel/40"
    aria-hidden="true"
  >
    <div className="marquee-track">
      <Row />
      <Row />
    </div>
  </div>
);
